export default "/images/no-color.svg?9d16b3e0e846a8a972af93c8d3526f7d";